import { defineMessages } from 'react-intl';

export default defineMessages({
  settingTitle: {
    id: 'settingTitle',
    description: 'settingTitle',
    defaultMessage: 'Settings',
  },
  saveText: {
    id: 'saveText',
    description: 'saveText',
    defaultMessage: 'Save',
  },
  settingUpdatedText: {
    id: 'settingUpdatedText',
    description: 'settingUpdatedText',
    defaultMessage: 'Your user settings have been updated.',
  },
});
